import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ComponentMaskContext = /*#__PURE__*/React.createContext(null);
function ComponentMaskProvider(_ref) {
  let {
    children,
    isMasked = false
  } = _ref;
  const value = {
    isMasked
  };
  return /*#__PURE__*/_jsx(ComponentMaskContext.Provider, {
    value: value,
    children: children
  });
}
const ComponentMaskConsumer = ComponentMaskContext.Consumer;
export { ComponentMaskContext, ComponentMaskProvider, ComponentMaskConsumer };